import React from 'react';
import { ButtonGroup, Button } from '@mui/material';
import { useLocation, CorporateLocation } from '../../contexts/LocationContext';

/**
 * Location toggle component designed for the top navigation bar
 * Displays horizontal button group for Pittsburgh/Tampa selection
 */
const ChillerLocationToggle: React.FC = () => {
  const { selectedLocation, setSelectedLocation } = useLocation();

  const handleLocationChange = (location: CorporateLocation) => {
    setSelectedLocation(location);
    // Clear any existing filter values when switching locations
    sessionStorage.removeItem('chillerFilterValues');
    sessionStorage.removeItem('chillerApprovalsFilterValues');
    // Reload the page to refresh data with new location
    window.location.reload();
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span
        style={{
          fontSize: '13px',
          fontWeight: 600,
          color: '#202223',
          whiteSpace: 'nowrap',
        }}
      >
        Location:
      </span>
      <ButtonGroup size="small" variant="outlined">
        <Button
          variant={selectedLocation === 'pittsburgh' ? 'contained' : 'outlined'}
          onClick={() => handleLocationChange('pittsburgh')}
          style={{
            textTransform: 'none',
            minWidth: '90px',
          }}
        >
          Pittsburgh
        </Button>
        <Button
          variant={selectedLocation === 'tampa' ? 'contained' : 'outlined'}
          onClick={() => handleLocationChange('tampa')}
          style={{
            textTransform: 'none',
            minWidth: '90px',
          }}
        >
          Tampa
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default ChillerLocationToggle;
